// removed by extract-text-webpack-plugin
module.exports = {"ScreenXXSMax":"(max-width: 543px)","button":"G6966a5","copy":"G16076d Gfbbf38"};